import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e48a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chips-msg-box-wrap" }
const _hoisted_2 = { class: "chips-msgbox-title-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "筹码设置", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_5 = { class: "msgbox-body-wrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "chips-msg-box-root",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chipsArray, (chip) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["chip-option", { active: chip.id === _ctx.chips.id }]),
            key: chip.id,
            onClick: _withModifiers(($event: any) => (_ctx.setChips(chip)), ["prevent"])
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chip.value, (value, valueIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "chip",
                key: valueIndex
              }, _toDisplayString(_ctx.toShortValue(value)), 1))
            }), 128))
          ], 10, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}